<template lang="pug">
  #CustomerTempModel.CustomerModel.CustomerModel-tempModel.p-3(
    :class="{ 'CustomerModel-active': showModel }"
  )
    .row.align-items-start.mb-2
      .col-10
        h2.mb-0 {{ title }}
      .col-2
        img.rounded-circle.closeIcon(
          v-lazy="iconUrl.IconClose",
          fluid,
          alt="Close Icon",
          @click="closeModel()"
        )
    .content
      .mb-2
        template.border-black(
          v-for="(invitation,index) in invitations"
        )
          .row.mb-3(@click="selectTempHandler(invitation.invite_id)")
            .col-2.d-flex.align-items-center.justify-content-center
              b-form-checkbox(
                :id="`checkbox-group-${index}`",
                name="selectTemps",
                :checked="isChecked(index)"
                :class="{ 'hidden-check': isChecked(index) }"
              )
                label.check-label(
                  v-if="isChecked(index)"
                ) {{ order(index)+ 1 }}
            .position-relative.col-10
              h4 {{ invitation.invite_title }}
              img.img-fluid.w-100.rounded(:src="invitation.invite_picture_url")

        infinite-loading(
          @infinite="infiniteHandler",
          :identifier="infiniteId",
          spinner="bubbles",
          ref="infiniteLoading"
        )
          .cursor-default.mt-3(slot="no-more") 無更多邀請函
          .cursor-default.mt-3(slot="no-results") 無更多邀請函
          .cursor-default.mt-3(slot="error") 發生錯誤，請重整重試一次
    .px-4
      .row.justify-content-center
        .col-6
          button.btn.btn-block.btn-primary(
            type="button",
            @click="invitationsPush()"
          ) 發送

</template>

<script>
import { mapState } from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';
import IconCloseUrl from '@/assets/images/icon/icon_close.png';
import $ from 'jquery';
import tempTextModel from '@/components/customerModel/tempTextModel.vue';
import tempSendPreviewModel from '@/components/customerModel/tempSendPreviewModel.vue';

// 模板顯示部分
import textInput from '@/components/modalTemplate/messageText/textInput.vue';
import imageMapInput from '@/components/modalTemplate/messageImageMap/imageMapInput.vue';
import carouselInput from '@/components/modalTemplate/messageCarousel/carouselInput.vue';

const _ = require('lodash');

export default {
  name: 'InvitationModel',
  components: {
    InfiniteLoading,
    tempTextModel,
    tempSendPreviewModel,
    textInput,
    imageMapInput,
    carouselInput
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    user: {
      type: [Object, null],
      default: null
    },
    multicastPush: {
      type: Boolean,
      default: false
    },
    users: {
      type: [Array, Object],
      default: null
    }
  },
  data() {
    return {
      iconUrl: {
        IconClose: IconCloseUrl
      },
      showModel: false,
      selectType: 'backend',
      selectTemps: [], // 選擇的模板
      tempModelCSS: {
        top: 0
      }, // 新增訊息模板的 CSS
      infiniteId: +new Date(),
      windowScrollHeight: 0, // 視窗原本位置
    };
  },
  mounted() {
    this.$EventBus.$on('openInvitationModel', () => {
      this.initHandler();
    });
  },
  methods: {
    initHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      // 初始化
      vm.selectTemps = [];
      vm.$store.commit('sa_invitation/resetInfiniteLoadingData');

      vm.$swal.close();
      vm.openModel();
      vm.infiniteId += 1;
    },
    infiniteHandler($state) {
      const vm = this;
      if (!vm.showModel) return;

      vm.$store.dispatch('sa_invitation/getInvitationsHandler', {
        current_page: vm.pagination.current_page + 1,
        per_page: vm.pagination.per_page
      }).then(() => {
        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    // 選擇模板
    selectTempHandler(id ) {
      const vm = this;
      const selectTemps_key = _.findKey(vm.selectTemps, (val) => val.invite_id === id);
      if (selectTemps_key) {
        vm.selectTemps.splice(selectTemps_key, 1);
      } else {
        const temps_key = _.findKey(vm.invitations, (val) => val.invite_id === id);
        if (temps_key) {
          vm.selectTemps.push(vm.invitations[temps_key]);
        }
      }
    },
    openModel() {
      this.showModel = true;
    },
    closeModel() {
      this.$emit('closeModelHandler');
      this.showModel = false;
    },
    changeTypeHandler(type = this.selectType) {
      const vm = this;
      vm.$store.commit('sa_temp/resetInfiniteLoadingData');
      vm.selectType = type;
      vm.infiniteId += 1;
    },
    // 發送邀請函
    async invitationsPush() {
      const vm = this;
      if (vm.selectTemps.length > 5) {
        vm.$swal.fire({
          icon: 'error',
          title: '超出邀請函發送限制，最多五則'
        });
        return;
      }
      vm.$swal.fire({
        title: '邀請函送出中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      const data = await _.map(vm.selectTemps, (val) => (
        val.invite_id
      ));

      if (vm.multicastPush) {
        const sendData = {
          member_uuid: _.map(vm.users, (val) => val.member_line_uuid || val.line_uuid),
          invite_id: data
        };
        vm.$store.dispatch('sa_chat/invitationsMulticastPushHandler', sendData)
          .then(() => {
            vm.$emit('closeModelHandler');
            vm.closeModel();
            vm.$swal.close();
            vm.$snotify.success(null, '邀請函送出成功');
          });
      } else {
        const sendData = {
          member_uuid: vm.user.member_uuid || vm.user.member_line_uuid,
          invite_id: data
        };

        vm.$store.dispatch('sa_chat/invitationsPushHandler', sendData)
          .then(() => {
            vm.$emit('closeModelHandler');
            vm.closeModel();
            vm.$swal.close();
            vm.$snotify.success(null, '邀請函送出成功');
          });
      }

    },
    // 把視窗移到最頂部
    scrollToTop() {
      return new Promise((resolve, reject) => {
        if ($('#CustomerTempModel').scrollTop() === 0) {
          resolve();
        } else {
          $('#CustomerTempModel').animate({
            scrollTop: 0
          }, 500);
        }
        setTimeout(() => {
          // 鎖定上下滑動 防止爆版
          $('#CustomerTempModel').addClass('overflow-hidden');
          resolve();
        }, 550);
      });
    },
    // 把視窗移到原本位置
    scrollToTarget() {
      const vm = this;
      return new Promise((resolve, reject) => {
        $('#CustomerTempModel').animate({
          scrollTop: vm.windowScrollHeight
        }, 500);
        setTimeout(() => {
          // 鎖定上下滑動 防止爆版
          $('#CustomerTempModel').removeClass('overflow-hidden');
          resolve();
        }, 550);
      });
    },
    isChecked(index) {
      const vm = this;
      const key = _.findKey(vm.selectTemps, (val) => val.invite_id === vm.invitations[index].invite_id);
      if (key) {
        return true;
      }
      return false;
    },
    order(index) {
      const vm = this;
      const key = _.findKey(vm.selectTemps, (val) => val.invite_id === vm.invitations[index].invite_id);
      return parseInt(key);
    }
  },
  beforeDestroy() {
    this.$EventBus.$off('openInvitationModel');
  },
  computed: {
    ...mapState({
      invitations: (state) => state.sa_invitation.invitations,
      pagination: (state) => state.sa_invitation.pagination
    }),
  }
};
</script>

<style scoped>
  .border-black{
    border: 0.2rem solid #000;
  }
</style>
